
import { Component, Emit, Prop, Mixins } from "vue-property-decorator"
import { mapState } from "vuex"
import api from "../../honcierge-api"
import ProcessingMixin from "../../mixins/processing-mixin"
import { Category, SubCategory } from "types/index"
import { ArticleState } from "src/store/articleType"

type _SubCategory = Pick<
  SubCategory["data"],
  "id" | "name" | "category" | "order"
>

@Component({
  computed: {
    ...mapState("article", {
      categories: (state) => (state as ArticleState).categories,
      subCategories: (state) => (state as ArticleState).subCategories,
    }),
  },
})
export default class SubCategorySearchForm extends Mixins(ProcessingMixin) {
  @Prop({ default: true })
  private enableName!: boolean
  private categories!: Category["view"][]
  private subCategories!: SubCategory["data"][]

  private name = ""
  private result: _SubCategory[] = []

  @Emit("resetPagination")
  public emitResetPagination(): void {
    /* */
  }
  @Emit("resetSelection")
  public emitResetSelection(): void {
    /* */
  }
  @Emit("searchResult")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private searchResult(result: _SubCategory[], totalPages: number) {
    /* */
  }

  public reset() {
    this.name = ""
    this.result = []
  }

  public async search(page = 1, sortBy = "id", descending = true) {
    this.startProcess()

    try {
      const response = await api.getSubCategories({
        categoryIds: this.categories.map((category) => category.id),
        excludeIds: this.subCategories.map((subCategory) => subCategory.id),
        name: this.name,
        page,
        per: 10,
        includeDisabled: false,
        fields: ["id", "name", "order"],
        withCategory: true,
        breadcrumbStatuses: ["default", "not_main"],
        sortBy,
        descending,
      })
      this.result = response.data.subCategories
      this.searchResult(
        response.data.subCategories.length > 0 ? this.result : [],
        response.data.meta.totalPages
      )
    } catch {
      this.$toasted.error("小カテゴリーの取得に失敗しました")
    } finally {
      this.endProcess()
    }
  }
}
